/* istanbul ignore file */
import { DeleteButton } from 'framework/ui/ui-builder';
import { useEmployeeOfferId } from 'domain/people/employee/offers/employeeOfferRouting';
import useEmployeeOfferService from 'domain/people/employee/offers/shared/employeeOfferService';
import { useEmployeeId } from 'domain/people/employee/employeeIdentityRouting';
import { useEmployeeUrl } from 'domain/shared/employee';

const deleteMessage = 'Do you really want to delete this Offer?';

const DeleteEmployeeOfferButton = (props: any) => {
  const offerId = useEmployeeOfferId();
  const { deleteById } = useEmployeeOfferService();
  const employeeId = useEmployeeId();
  const { getTimelineUrl } = useEmployeeUrl();

  return (
    <DeleteButton
      {...props}
      displayMessage={deleteMessage}
      deleteMethod={() => deleteById(offerId)}
      afterDelete={{
        redirectUrl: getTimelineUrl(employeeId || ''),
        successMessage: 'The Offer has been successfully deleted.',
        errorMessage: `Can't delete Offer.`,
      }}
    />
  );
};

export default DeleteEmployeeOfferButton;
